// for a given dataSize and pageSize, return the max number of pages
const PageMax = (dataSize, pageZSize) =>
  pageZSize >= dataSize ? 1 : Math.ceil(dataSize / pageZSize);

export default {
  PageMax,
};
